import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Roles API.
 *
 * This file drives:
 * - **Enhanced API**: computed endpoint keys in `enhanceEndpoints`
 * - **Hook re-exports**: clean name → generated name mapping
 * - **MSW mock factories**: HTTP method + URL path pattern
 *
 * When the OpenAPI spec changes and codegen regenerates, update this
 * file to keep everything in sync.
 */

/**
 * Endpoint definitions keyed by clean export name.
 *
 * Each entry maps a human-friendly name to:
 * - `generated` — the codegen-produced RTK Query endpoint name, derived from the OpenAPI operationId
 * - `method` — HTTP verb
 * - `path` — URL pattern (MSW-compatible `:param` syntax)
 */
export const ROLES_API_ENDPOINTS = {
  listRoles: {
    generated: 'rolesAdminControllerListRolesV1',
    method: 'get',
    path: '/api/v1/admin/roles',
  },
  getRole: {
    generated: 'rolesAdminControllerGetRoleV1',
    method: 'get',
    path: '/api/v1/admin/roles/:id',
  },
  createRole: {
    generated: 'rolesAdminControllerCreateRoleV1',
    method: 'post',
    path: '/api/v1/admin/roles',
  },
  updateRole: {
    generated: 'rolesAdminControllerUpdateRoleV1',
    method: 'put',
    path: '/api/v1/admin/roles/:id',
  },
  deleteRole: {
    generated: 'rolesAdminControllerRemoveRoleV1',
    method: 'delete',
    path: '/api/v1/admin/roles/:id',
  },
} as const satisfies Record<string, EndpointDef>;

export type RolesEndpointName = keyof typeof ROLES_API_ENDPOINTS;
